import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useInfrastructuresManager from "./hooks/useInfrastructuresManager";

import InfrastructureStats from "./components/InfrastructureStats";
import InfrastructureToolbar from "./components/InfrastructureToolbar";
import InfrastructureTable from "./components/InfrastructureTable";
import InfrastructureFormDrawer from "./components/InfrastructureFormDrawer";

export default function InfrastructuresManager() {
  useScrollToTop();

  const {
    loading,
    saving,
    stats,
    query,
    gpsFilter,
    visibleInfrastructures,
    filteredInfrastructures,
    visibleCount,
    drawer,
    demoMode,

    setQuery,
    setGpsFilter,
    resetFilters,
    loadMore,
    refreshData,

    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleCreateInfrastructure,
    handleUpdateInfrastructure,
    handleDeleteInfrastructure,
  } = useInfrastructuresManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1500px] space-y-5">
        <InfrastructureToolbar
          query={query}
          gpsFilter={gpsFilter}
          loading={loading}
          demoMode={demoMode}
          onQueryChange={setQuery}
          onGpsFilterChange={setGpsFilter}
          onReset={resetFilters}
          onRefresh={refreshData}
          onCreate={openCreateDrawer}
        />

        <InfrastructureStats stats={stats} />

        <InfrastructureTable
          infrastructures={visibleInfrastructures}
          loading={loading}
          totalRows={filteredInfrastructures.length}
          visibleCount={visibleCount}
          demoMode={demoMode}
          onLoadMore={loadMore}
          onEdit={openEditDrawer}
          onDelete={handleDeleteInfrastructure}
        />
      </div>

      <InfrastructureFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreateInfrastructure}
      />

      <InfrastructureFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        infrastructure={drawer.infrastructure}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdateInfrastructure}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}